/**
 * Global toast bridge — allows non-React code (like QueryClient MutationCache)
 * to trigger toasts. The ToastProvider registers its showToast here on mount.
 */
type ToastType = 'success' | 'error' | 'info'
type ShowToastFn = (type: ToastType, message: string) => void

let _showToast: ShowToastFn | null = null

/** Called by ToastProvider on mount to register its showToast function */
export function registerToast(fn: ShowToastFn) {
  _showToast = fn
}

/** Called by ToastProvider on unmount to clear the reference */
export function unregisterToast() {
  _showToast = null
}

/** Fire a toast from anywhere (no-op if ToastProvider is not mounted) */
export function globalShowToast(type: ToastType, message: string) {
  _showToast?.(type, message)
}
